module.exports = __webpack_public_path__ + "static/media/icon-client-services-circle.357bc515.svg";